import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import { PaycellInfoDialogAction } from './paycell-info-dialog.action';
import './paycell-info-dialog.less';
/* @ngInject */
export default class PaycellInfoDialogController implements ActionHandler {
  private dialogElement;

  protected approve: () => void;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#paycell-info-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof PaycellInfoDialogAction) {
      this.openDialog();
    }
  }

  private openDialog() {
    this.dialogElement.open();
  }

  public close() {
    this.dialogElement.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/paycell-info-dialog/paycell-info-dialog.controller.ts